import { r2x } from "..";
import apifetch from "../utils/apifetch";
import parseXML from "../utils/parseXML";
import { fetchXML2Metadata } from "../xmlrdb-metadata/XML2Metadata";
import XMLRDBNavigation from "../xmlrdb-metadata/XMLRDBNavigation";
import RootElement from "./RootElement";
import { appendSubElements } from "./XML2ViewModelUtils"

export async function rawxmlToViewModel(meta: string, data:string, url: string): Promise<RootElement>{
  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(meta, "text/xml");
  const nav = await XMLRDBNavigation.getNavigation(xmlDoc.documentElement); // Initialize XMLRDBNavigation with the root element
  const vm = xml2ViewModel(data, nav, url);
  return vm;
}

export function xml2ViewModel(xml: XMLDocument | string , metadata: XMLRDBNavigation, dataURL: string , options: Object = {}): RootElement {
  let xmlElement: XMLDocument;
  if (typeof xml === "string")
    xmlElement = parseXML(xml)
  else
    xmlElement = xml;

  let node = xmlElement.firstElementChild;
  let dataElement = new RootElement({ rootMetadata: metadata, subElementMetadata: metadata.children, url: dataURL, ...options });
  appendSubElements(node, dataElement, metadata);
  return dataElement;
}


/**
 * Legt ein neues View-Model passend zu metadata an.
 * Das übergebene XML kann auch leer sein. Es soll aber benutzt werden um Lookup_Informationen vorzubelegen
 * @param {XMLDocument | string} xml mit initialen Daten. Kann ungesetzt (null) sein.
 * @param {import("../xmlrdb-metadata/XMLRDBNavigation").default} metadata
 * @returns {import("./DataElement").default}
 */
export function emptyViewModel(xml: XMLDocument | string | undefined | null , metadata: XMLRDBNavigation, dataURL: string , options: Object = {}): RootElement {
  let xmlElement;
  if (typeof xml === "string")
    xmlElement = parseXML(xml)
  else
    xmlElement = xml;

  let node = xmlElement?.firstElementChild;
  let dataElement = new RootElement({ rootMetadata: metadata, subElementMetadata: metadata.children, url: dataURL, ...options });
  if (node) appendSubElements(node, dataElement, metadata);
  let rootMeta = metadata.getElement("1");
  dataElement.addSubElement(rootMeta, rootMeta.newDataElement(dataElement, true), false);
  return dataElement;
}

interface XML2ViewModelOptions {
  r2x: r2x;
  xmlDoc: string;
  queryParams?: string;
  method?: "POST" | "GET" ;
  body?: string;
  id?: string;
  options?: Object;
}

export async function getForm({ r2x = "R2X", xmlDoc, queryParams, method, body, id, options = {} }: XML2ViewModelOptions): Promise<RootElement> {
  let url = `xmlrdb/read/${r2x}/${xmlDoc}`;
  if (id) {
    url += "/" + id
  }
  if (queryParams) {
    url += "?" + queryParams
  }
  const [xmlstr, metadata] = await Promise.all([
    apifetch(url, { body, method }).then(e => e.text()),
    fetchXML2Metadata(r2x, xmlDoc)
  ]);
  return xml2ViewModel(xmlstr, metadata, url, options);
}